module.exports = __webpack_public_path__ + "img/plus_active.fa272cad.svg";